export enum UserRole {
    // Legacy roles for backward compatibility
    ADMIN = 'admin',
    CTO = 'cto',
    INTERNAL_USER = 'internal_user',
    MARKETING = 'marketing',
    EXECUTOR = 'executor',
}
